"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializerHelper = void 0;
var ethers_1 = require("ethers");
var multicall_1 = require("./multicall");
var bmath_1 = require("./bmath");
var constants_1 = require("./constants");
var address_1 = require("./utils/address");
var bignumber_1 = require("./utils/bignumber");
var deployments_1 = __importDefault(require("./deployments"));
var provider_1 = require("./utils/provider");
var MAX_UINT112 = new bignumber_1.BigNumber(2).pow(112);
var fromFP = function (num) { return num.div(MAX_UINT112); };
var InitializerHelper = /** @class */ (function () {
    function InitializerHelper(provider, network, pool, userAddress) {
        this.network = network;
        this.pool = pool;
        this.userAddress = userAddress;
        this.tokenPrices = {};
        this.userAllowances = {};
        this.userBalances = {};
        this.userCredit = bmath_1.bnum(0);
        this.provider = provider_1.toProvider(provider);
        this.lastUpdate = 0;
        this.waitForUpdate = this.update();
    }
    Object.defineProperty(InitializerHelper.prototype, "category", {
        get: function () {
            return this.pool.category;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "name", {
        get: function () {
            return this.pool.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "symbol", {
        get: function () {
            return this.pool.symbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "address", {
        get: function () {
            return this.initializer.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "initializer", {
        get: function () {
            return this.pool.initializer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "tokens", {
        get: function () {
            return this.initializer.tokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "shouldUpdate", {
        get: function () {
            var timestamp = Math.floor(+new Date() / 1000);
            return timestamp - this.lastUpdate > 120;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializerHelper.prototype, "totalCreditedWETH", {
        get: function () {
            return this.initializer.totalCreditedWETH;
        },
        enumerable: false,
        configurable: true
    });
    InitializerHelper.prototype.setUserAddress = function (userAddress) {
        this.userAddress = userAddress;
        this.waitForUpdate = this.update();
    };
    InitializerHelper.prototype.getOracle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oracleAddress, oracleABI;
            return __generator(this, function (_a) {
                oracleAddress = deployments_1.default[this.network].uniswapOracle;
                oracleABI = require('./abi/IIndexedUniswapV2Oracle.json');
                return [2 /*return*/, new ethers_1.Contract(oracleAddress, oracleABI, this.provider)];
            });
        });
    };
    InitializerHelper.prototype.getTokenBySymbol = function (symbol) {
        for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
            var token = _a[_i];
            if (token.symbol.toLowerCase() == symbol.toLowerCase()) {
                return token;
            }
        }
        throw new Error("Token with symbol " + symbol + " not found in pool.");
    };
    InitializerHelper.prototype.getTokenByAddress = function (address) {
        for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
            var token = _a[_i];
            if (token.address.toLowerCase() == address.toLowerCase()) {
                return token;
            }
        }
        throw new Error("Token with address " + address + " not found in pool.");
    };
    InitializerHelper.prototype.getUserTokenData = function (address, amount) {
        if (!this.userAddress)
            return {};
        var allowance = this.userAllowances[address];
        if (allowance.gte(amount))
            return {
                remainingApprovalAmount: '0x0',
                allowance: '0x0',
                balance: '0x0'
            };
        var remainingApprovalAmount = amount.minus(allowance);
        return {
            remainingApprovalAmount: bignumber_1.toHex(remainingApprovalAmount),
            allowance: bignumber_1.toHex(allowance),
            balance: bignumber_1.toHex(this.userBalances[address])
        };
    };
    InitializerHelper.prototype.getPrices = function (tokens_) {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, oracle, prices, fpValues, e_1, emptyArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokens = tokens_.map(address_1.toAddress);
                        return [4 /*yield*/, this.getOracle()];
                    case 1:
                        oracle = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, oracle.computeAverageTokenPrices(tokens, constants_1.INITIALIZER_MIN_TWAP, constants_1.INITIALIZER_MAX_TWAP)];
                    case 3:
                        prices = _a.sent();
                        fpValues = prices.map(function (p) { return fromFP(bmath_1.bnum(p._x)); });
                        return [2 /*return*/, fpValues];
                    case 4:
                        e_1 = _a.sent();
                        console.log(e_1);
                        emptyArray = new Array(tokens.length);
                        return [2 /*return*/, emptyArray.fill(new bignumber_1.BigNumber(0))];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.updateUserData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, tokenDatas, abi, pool, _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.userAddress)
                            return [2 /*return*/];
                        tokens = this.tokens;
                        return [4 /*yield*/, multicall_1.getTokenUserData(this.provider, this.userAddress, this.initializer.address, tokens)];
                    case 1:
                        tokenDatas = _c.sent();
                        abi = require('./abi/IPoolInitializer.json');
                        pool = new ethers_1.Contract(this.initializer.address, abi, this.provider);
                        _a = this;
                        _b = bmath_1.bnum;
                        return [4 /*yield*/, pool.getCreditOf(this.userAddress)];
                    case 2:
                        _a.userCredit = _b.apply(void 0, [_c.sent()]);
                        tokenDatas.forEach(function (_a, i) {
                            var allowance = _a.allowance, balance = _a.balance;
                            var address = tokens[i].address;
                            _this.userAllowances[address] = allowance;
                            _this.userBalances[address] = balance;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.updateTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initializerAbi, initializer, tokens, desiredAmounts, prices;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initializerAbi = require('./abi/IPoolInitializer.json');
                        initializer = new ethers_1.Contract(this.initializer.address, initializerAbi, this.provider);
                        tokens = this.tokens.map(function (t) { return t.address; });
                        return [4 /*yield*/, initializer.getDesiredAmounts(tokens, { gasLimit: 1000000 })];
                    case 1:
                        desiredAmounts = (_a.sent()).map(bmath_1.bnum);
                        return [4 /*yield*/, this.getPrices(tokens)];
                    case 2:
                        prices = _a.sent();
                        desiredAmounts.forEach(function (amount, i) {
                            var token = _this.tokens[i];
                            var targetBalance = token.targetBalance;
                            var balance = targetBalance.minus(amount);
                            token.amountRemaining = amount;
                            token.balance = balance;
                            _this.tokenPrices[tokens[i]] = prices[i];
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastUpdate = Math.floor(+new Date() / 1000);
                        return [4 /*yield*/, Promise.all([this.updateTokens(), this.updateUserData()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.checkTokenPriceReady = function (token_) {
        return __awaiter(this, void 0, void 0, function () {
            var oracle, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOracle()];
                    case 1:
                        oracle = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, oracle['computeAverageEthForTokens(address,uint256,uint256,uint256)'](address_1.toAddress(token_), 0, constants_1.INITIALIZER_MIN_TWAP, constants_1.INITIALIZER_MAX_TWAP)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        err_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.updatePrice = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var oracle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOracle()];
                    case 1:
                        oracle = _a.sent();
                        return [4 /*yield*/, oracle.updatePrice(address_1.toAddress(token)).then(function (tx) { return tx.wait(); })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InitializerHelper.prototype.getExpectedCredit = function (token_, amount_) {
        return __awaiter(this, void 0, void 0, function () {
            var amount, address, token, credit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        amount = bmath_1.bnum(amount_);
                        address = address_1.toAddress(token_);
                        token = this.getTokenByAddress(address);
                        credit = this.tokenPrices[address.toLowerCase()].times(amount);
                        return [2 /*return*/, __assign({ credit: bignumber_1.toHex(credit), displayCredit: bignumber_1.formatBalance(credit, 18, 4), address: token.address, decimals: token.decimals }, this.getUserTokenData(token.address, amount))];
                }
            });
        });
    };
    InitializerHelper.prototype.getExpectedCredits = function (tokens_, amounts) {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, amountsIn, details, credit;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokens = tokens_.map(address_1.toAddress);
                        amountsIn = amounts.map(bmath_1.bnum);
                        details = [];
                        credit = bmath_1.bnum(0);
                        tokens.forEach(function (tokenAddress, i) {
                            var token = _this.getTokenByAddress(tokenAddress);
                            details.push(__assign({ address: token.address, decimals: token.decimals }, _this.getUserTokenData(token.address, amountsIn[i])));
                        });
                        tokens.forEach(function (token, i) {
                            var price = _this.tokenPrices[token];
                            var amount = amountsIn[i];
                            credit = credit.plus(price.times(amount));
                        });
                        return [2 /*return*/, [
                                {
                                    credit: bignumber_1.toHex(credit),
                                    displayCredit: bignumber_1.formatBalance(credit, 18, 4)
                                },
                                details
                            ]];
                }
            });
        });
    };
    return InitializerHelper;
}());
exports.InitializerHelper = InitializerHelper;
